import { render, staticRenderFns } from "./InputChipBox.vue?vue&type=template&id=4bf840de&scoped=true&"
import script from "./InputChipBox.vue?vue&type=script&lang=js&"
export * from "./InputChipBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf840de",
  null
  
)

export default component.exports